module.exports = __webpack_public_path__ + "img/143.3.7c55d7dc.png";